import { supportsSouthChinaSeaInset } from './inset'

// 本地地图的视图设置；旧roam=false仍同时禁用缩放与拖动。
export const MAP_MAX_ZOOM = 1024

export function mapInteraction (option = {}) {
  // 附图依赖固定主图取景，临时锁定漫游，不覆盖用户原有开关。
  if (option.southChinaSeaInset === true && supportsSouthChinaSeaInset(option)) return { pan: false, zoom: false, roam: false }
  const pan = typeof option.allowPan === 'boolean' ? option.allowPan : option.roam !== false && option.roam !== 'scale'
  const zoom = typeof option.allowZoom === 'boolean' ? option.allowZoom : option.roam !== false && option.roam !== 'move'
  return { pan, zoom, roam: pan && zoom ? true : pan ? 'move' : zoom ? 'scale' : false }
}

export function initialMapView (option = {}) {
  const number = Number(option.zoom)
  const zoom = option.zoom == null || option.zoom === '' || !Number.isFinite(number) ? 1 : Math.max(.5, Math.min(MAP_MAX_ZOOM, number))
  const result = { zoom }, lng = option.centerLng, lat = option.centerLat
  if (typeof lng === 'number' && typeof lat === 'number' && Number.isFinite(lng) && Number.isFinite(lat) && Math.abs(lng) <= 180 && Math.abs(lat) <= 90) result.center = [lng, lat]
  return result
}

export const isRegionCountMode = option => option && option.displayMode === 'regions'
